import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';

const DonutChart = ({ data, total }) => {
  const { t } = useTranslation();
  const RADIUS = 70;
  const STROKE = 16;
  const NORM = 2 * Math.PI * RADIUS;
  let offset = 0;
  const segments = (data && data.length > 0 ? data : []).map(d => {
    const pct = total > 0 ? d.value / total : 0;
    const seg = { ...d, pct, offset, dash: pct * NORM };
    offset += pct * NORM;
    return seg;
  });
  return (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width={180} height={180} viewBox='0 0 180 180'>
        {/* background ring */}
        <circle cx='90' cy='90' r={RADIUS} fill='none' stroke={S.borderLight} strokeWidth={STROKE} />
        {segments.map((seg, i) => (
          <circle
            key={i}
            cx='90'
            cy='90'
            r={RADIUS}
            fill='none'
            stroke={seg.color}
            strokeWidth={STROKE}
            strokeDasharray={`${seg.dash} ${NORM - seg.dash}`}
            strokeDashoffset={NORM / 4 - seg.offset}
            style={{ transform: 'rotate(-90deg)', transformOrigin: '90px 90px', transition: 'stroke-dasharray 0.4s' }}
          />
        ))}
      </svg>
      <div style={{ position: 'absolute', textAlign: 'center' }}>
        {/* null total = the breakdown has not been resolved yet. Printing
            the raw value would render a confident "0" over an empty ring
            for a tenant that simply has not finished loading. */}
        <div style={{ fontSize: 26, fontWeight: 800, color: S.textPrimary }}>{total == null ? '—' : total}</div>
        <div style={{ fontSize: 11, color: S.textMuted, fontWeight: 600 }}>{t('dashboard.total')}</div>
      </div>
    </div>
  );
};

export default DonutChart;
